import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// import Home from './components/Home';

import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import SolMartUI from './pages/ExPage';
import { AboutPage } from './components/AboutUs';
import ContactUs from './components/Contact';


function App() {
  return (
    <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/ex" element={<SolMartUI />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
    </Router>
   
  );
}

export default App;
